import type { Action } from './actions'

import type {
    FilterShortDTO,
    FormFaqShortDTO,
    MetaShortDTO,
    QuestionShortDTO,
    ThemeShortDTO
} from 'shared/types/api'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = {|
    +metaData: ?MetaShortDTO,
    +formData: ?FormFaqShortDTO,
    +categories: ?Array<FilterShortDTO>,
    +themes: ?Array<ThemeShortDTO>,
    +questions: Array<QuestionShortDTO>,
    +questionsPagesDisplayed: number, //1, 2, 3, ...
    +legalMentions: ?string,
    +selectedCategory: string,
    +selectedTheme: ?ThemeShortDTO,
    +success: ?boolean,
    +postedData: ?any,
    dataLoaded: ?boolean,
    +error?: any,
    +networkError?: any,
    +sendFormError: ?any
|}

const initialState: State = {
    metaData: null,
    formData: null,
    categories: [],
    themes: [],
    questions: [],
    questionsPagesDisplayed: 1,
    legalMentions: '',
    selectedCategory: '',
    selectedTheme: null,
    success: false,
    postedData: null,
    dataLoaded: false,
    sendFormError: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'PAGE_DATA_FAQ_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(state, action, endpoints.pages.faq)
        case 'FAQ_FORM_DATA_RESPONSE':
            return {
                ...state,
                formData: action.formData
            }
        case 'FAQ_CATEGORY_SELECTED':
            return {
                ...state,
                selectedCategory: action.selectedCategory,
                questionsPagesDisplayed: 1
            }
        case 'FAQ_THEME_SELECTED':
            return {
                ...state,
                selectedTheme: action.selectedTheme,
                success: false,
                sendFormError: false
            }
        case 'FAQ_MORE_QUESTIONS':
            return {
                ...state,
                questionsPagesDisplayed: state.questionsPagesDisplayed + 1
            }
        case 'FAQ_FORM_POST_SUCCESS':
            return {
                ...state,
                postedData: action.postedData,
                success: true,
                sendFormError: false
            }
        case 'FAQ_FORM_RESET_SUCCESS':
            return {
                ...state,
                success: false,
                selectedTheme: null
            }
        case 'FAQ_FORM_POST_ERROR':
            return {
                ...state,
                sendFormError: action.error
            }
        case 'FAQ_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
